export default __webpack_public_path__ + "static/samplepdf-0e7645e241052a494ba27830ba20e35b.pdf";